// @ts-nocheck
import { extendedStyles } from "@insite/content-library/Widgets/CompactHeader/Logo";
import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import useCardStyles from "@store/Library/Widgets/Card/useCardStyles";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React from "react";
import styled, { css, CSSProperties } from "styled-components";

export type CardFooterStyles = InjectableCss;

const CardFooter = styled.div<InjectableCss>`
    ${injectCss}
`;
export interface CardFooterProps {
    extendedStyles?: CardFooterStyles;
    overrideStyles?: CardFooterStyles;
    justifyContent?: CSSProperties["justifyContent"];
    children?: React.ReactNode;
    className?: string;
}
const CardFooterComponent: React.FC<CardFooterProps> = ({
    extendedStyles,
    children,
    overrideStyles,
    justifyContent = "normal",
    className,
}) => {
    const defaultStyles = useCardStyles().footer;
    const footerStyles: CardFooterStyles = {
        css: css`
            display: flex;
            ${defaultStyles?.css}
            justify-content: ${justifyContent};
        `,
    };
    const styles = useExpandProps(footerStyles, extendedStyles, overrideStyles);
    return (
        <CardFooter className={className} {...styles}>
            {children}
        </CardFooter>
    );
};

export default CardFooterComponent;
